import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles((theme) => ({
    htmlContainer: {
        border: `1px solid ${theme.palette.secondary.light}`,
        height: '100%',
        borderRadius: 7,
        padding: 5,
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
            minHeight: 400
        },
        minHeight: 500,
    },
    textareaHTML: {
        width: '100%',
        maxWidth: '100%',
        minWidth: '100%',
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: 7,
        padding: '1rem',
        paddingBottom: 42,
        color: theme.palette.text.primary,
        lineHeight: 1.5,
        '&:focus': {
            borderColor: theme.palette.primary.main,
            outline: 'none'
        }
    },
    textAreaContainer: {
        position: 'relative',
    },
    htmlLabel: {
        top: 10,
        left: 5,
        transform: 'translate(14px, -6px) scale(0.75)',
        background: theme.palette.background.paper,
        padding: '0 5px'
    },
    showHide: {
        position: 'absolute',
        bottom: 13,
        left: 8,
        background: theme.palette.background.paper,
        '&:hover': {
            background: theme.palette.background.paper,
        },
        '& svg': {
            marginRight: 0
        }
    },
    cardContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    },
    cardContent: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column'
    },
    label: {
        fontSize: 14,
        color: theme.palette.text.primary
    },
    emailAdd: {
        backgroundColor: theme.palette.grey[300],
        padding: theme.spacing(0.5, 1),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.shape.borderRadius,
    },
    lixoIcon: {
        background: theme.palette.error.main,
        borderRadius: '100%',
        width: 25,
        height: 25,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: theme.spacing(.5),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.error.dark
        },
        '& svg': {
            width: 15,
            height: 15,
            margin: 0,
            padding: 0,
        }
    },
    maisIcon: {
        marginLeft: theme.spacing(2),
        '& svg': {
            margin: 0,
            padding: 0,
        }
    },
    formCadastro: {
        overflowY: 'auto',
        flex: '1 1 auto',
        height: 0,
        marginTop: theme.spacing(2)
    }
}));
